import { SharedAngular } from '@Client/@types/sharedAngular';
import angular, {
  ILocationService,
  ITimeoutService,
  IWindowService
} from 'angular';
import IModelerWorkflowDetail from '@Shared.Angular/@types/core/contracts/queryModel/modeler/modelerWorkflowDetail';

class RunnerPrintFlowModelSchemaController {
  public static $inject = [
    'flowinglyDiagramService',
    'goService',
    '$timeout',
    '$window',
    'documentApiService',
    '$location'
  ];

  constructor(
    private flowinglyDiagramService: SharedAngular.FlowinglyDiagramService,
    private goService: GoJS,
    private $timeout: ITimeoutService,
    private $window: IWindowService,
    private documentApiService: SharedAngular.DocumentApiService,
    private $location: ILocationService
  ) {
    this.displayFlowModel();
  }

  private flowModel: IModelerWorkflowDetail;
  private diagram: any;

  private displayFlowModel() {
    this.onAnimationFinished = this.onAnimationFinished.bind(this);

    const flowModelSchemaId = this.$location.search().id;

    this.documentApiService
      .getFlowModelSchema(flowModelSchemaId)
      .then((flowModel) => {
        this.flowModel = flowModel;
        // For printing we always want to layout like it's a Process Map
        this.flowModel.isProcessMap = true;

        return this.$timeout(() => {
          this.diagram = this.flowinglyDiagramService.generateProcessModel({
            flow: flowModel,
            applyAvatar: false,
            modelCustomArgs: {
              scrollMode: this.goService.Diagram.DocumentScroll
            },
            allowSelect: true,
            dynamicInitialHeight: this.$window.innerHeight
          });

          if (typeof this.diagram !== 'undefined') {
            this.diagram.addDiagramListener(
              'AnimationFinished',
              this.onAnimationFinished
            );
            (window as any).diagram = this.diagram;
          }
        });
      });
  }

  private onAnimationFinished(e) {
    this.diagram.links.each((link) => {
      link.invalidateRoute();
    });
    this.$timeout(() => {
      if (typeof hiqPdfConverter_startConversion === 'function') {
        hiqPdfConverter_startConversion();
      }
    }, 1000);
  }
}
angular
  .module('flowingly.runner.print')
  .controller(
    'runnerPrintFlowModelSchemaController',
    RunnerPrintFlowModelSchemaController
  );
